var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparisonEthnicity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 4,
    viewBox: "0 0 31 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.25,
    x2: 27.8,
    y2: -0.25,
    transform: "matrix(-1 0 0 1 30.6338 1.39648)",
    stroke: "#011C25",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.25,
    x2: 2.99766,
    y2: -0.25,
    transform: "matrix(0.765164 -0.643835 -0.64525 -0.763971 0.544922 3)",
    stroke: "#011C25",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonEthnicity);
export default __webpack_public_path__ + "static/media/comparisonEthnicity.e1dda8ec3c0c5e9795fe1d52fdc15644.svg";
export { ForwardRef as ReactComponent };